import { createClient } from '@supabase/supabase-js';
import { BROWSER_SUPABASE_AUTH_OPTIONS } from '@xer/web-shared';
import type { Database } from '../types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
if (!supabaseUrl) {
  throw new Error('VITE_SUPABASE_URL environment variable is required');
}

const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
if (!supabaseAnonKey) {
  throw new Error('VITE_SUPABASE_ANON_KEY environment variable is required');
}

// Auth options (detectSessionInUrl: false + persistSession + autoRefreshToken)
// are shared with analytics-frontend via @xer/web-shared — rationale lives there.
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: BROWSER_SUPABASE_AUTH_OPTIONS,
});
